import React from 'react'
import { Warning } from 'components/icons'

/** A Custom View's notice: an error (red) or a warning (amber), announced as an alert. */
export default function Callout({
  children,
  tone = 'error'
}: {
  children: React.ReactNode
  tone?: 'error' | 'warning'
}) {
  const styles = tone === 'error' ? 'bg-really-light-red border-light-red' : 'bg-really-light-yellow border-alert'
  return (
    <div role="alert" className={`flex items-start gap-2.5 rounded-lg border px-3.5 py-2.5 text-sm ${styles}`}>
      <Warning className={`shrink-0 mt-0.5 ${tone === 'error' ? 'text-red' : 'text-orange'}`} />
      <span className="text-primary">{children}</span>
    </div>
  )
}
